const BASE = process.env.REACT_APP_API_URL || '';
const TOKEN_KEY = 'portfolio_admin_token';

const headers = (auth = false) => {
    const h = { 'Content-Type': 'application/json' };
    if (auth) {
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) h['Authorization'] = `Bearer ${token}`;
    }
    return h;
};

// 인증
export const login = async (password) => {
    const res = await fetch(`${BASE}/api/auth/login`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ password }),
    });
    if (!res.ok) throw new Error((await res.json()).message);
    const { token } = await res.json();
    localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => localStorage.removeItem(TOKEN_KEY);

export const isAuthed = () => !!localStorage.getItem(TOKEN_KEY);

// 항목 조회 (공개)
export const getEntries = async (category) => {
    const url = category ? `${BASE}/api/entries?category=${category}` : `${BASE}/api/entries`;
    const res = await fetch(url);
    if (!res.ok) throw new Error('항목 조회 실패');
    return res.json();
};

export const getEntry = async (id) => {
    const res = await fetch(`${BASE}/api/entries/${id}`);
    if (!res.ok) throw new Error('항목 조회 실패');
    return res.json();
};

// 항목 CRUD (관리자)
export const createEntry = async (entry) => {
    const res = await fetch(`${BASE}/api/entries`, {
        method: 'POST',
        headers: headers(true),
        body: JSON.stringify(entry),
    });
    if (!res.ok) throw new Error((await res.json()).message);
};

export const updateEntry = async (id, entry) => {
    const res = await fetch(`${BASE}/api/entries/${id}`, {
        method: 'PUT',
        headers: headers(true),
        body: JSON.stringify(entry),
    });
    if (!res.ok) throw new Error((await res.json()).message);
};

export const deleteEntry = async (id) => {
    const res = await fetch(`${BASE}/api/entries/${id}`, {
        method: 'DELETE',
        headers: headers(true),
    });
    if (!res.ok) throw new Error((await res.json()).message);
};

// 프로필 조회 (공개)
export const getProfile = async () => {
    const res = await fetch(`${BASE}/api/profile`);
    if (!res.ok) throw new Error('프로필 조회 실패');
    return res.json();
};

// 프로필 저장 (관리자)
export const updateProfile = async (profile) => {
    const res = await fetch(`${BASE}/api/profile`, {
        method: 'PUT',
        headers: headers(true),
        body: JSON.stringify(profile),
    });
    if (!res.ok) throw new Error((await res.json()).message);
};

export const generateId = () =>
    Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

// 서버 정리 (관리자)
export const cleanupStatic = async () => {
    const res = await fetch(`${BASE}/api/maintenance/cleanup-static`, {
        method: 'POST',
        headers: headers(true),
    });
    if (!res.ok) throw new Error((await res.json()).message);
    return res.json();
};

export const uploadImage = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('파일 읽기 실패'));
        reader.onload = async (e) => {
            try {
                const id = generateId();
                const res = await fetch(`${BASE}/api/images`, {
                    method: 'POST',
                    headers: headers(true),
                    body: JSON.stringify({ id, filename: file.name, mimetype: file.type, data: e.target.result }),
                });
                if (!res.ok) throw new Error('업로드 실패');
                resolve(await res.json());
            } catch (err) {
                reject(err);
            }
        };
        reader.readAsDataURL(file);
    });
